import React from "react";

import { CloseOutlined, InfoCircleOutlined } from "@ant-design/icons";

import "./InviteHeader.css";
import StyledTooltip from "../../../../../Common/UIComponents/StyledTooltip";

export default function InviteHeader({ handleShowInvite }) {
  return (
    <div className="InviteModal__HeaderContainer">
      <div className="InviteModal__HeaderText">
        External Sharing
        <StyledTooltip
          title="Allows sharing with external domains, allowing them to submit samples on your behalf."
          placement="top"
        >
          <InfoCircleOutlined
            className="InviteModal__HeaderInfoIcon"
            aria-label="About external sharing"
          />
        </StyledTooltip>
      </div>
      <CloseOutlined
        className="InviteModal__CloseIcon"
        aria-label="Close"
        onClick={() => handleShowInvite(false)}
      />
    </div>
  );
}
